import { render, staticRenderFns } from "./SettingsFakeDoorView.vue?vue&type=template&id=56e47275&"
import script from "./SettingsFakeDoorView.vue?vue&type=script&lang=ts&"
export * from "./SettingsFakeDoorView.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsFakeDoorView.vue?vue&type=style&index=0&id=56e47275&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports